import { cloudChiprApi } from "@/services/cloudchipr.api";
import { languagePreferenceKey } from "@/components/common/language-select/utils/constants/constants";

export const languageEndpointSelector =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select({
    key: languagePreferenceKey,
  });
